import { render, staticRenderFns } from "./PaymentRedirectPage.vue?vue&type=template&id=20243e22&"
import script from "./PaymentRedirectPage.vue?vue&type=script&lang=js&"
export * from "./PaymentRedirectPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRedirectPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports